
import { defineComponent, PropType } from 'vue';
import type { PurchaseProduct } from "@white-label-types/parking-booking";
import type { Total } from '@white-label-types/parking-checkout';

import ReceiptBookingOrders from '../receipt-booking-orders/receipt-booking-orders.vue';
import ReceiptBookingOrder from '../receipt-booking-order/receipt-booking-order.vue';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { TicketPreloader, AdditionalInfoPreloader, PartnerizeTracking } from 'ui-shared-components'
// MIGRATION-TODO: This will be removed when migrating these components to features

export default defineComponent({
  components: {
    ReceiptBookingOrder,
    ReceiptBookingOrders,
    TicketPreloader,
    AdditionalInfoPreloader,
    PartnerizeTracking
  },

  props: {
    items: {
      type: Array as PropType<PurchaseProduct[]>,
      required: true,
    },

    orderTotals: {
      type: Object as PropType<Total>,
      default: () => ({}),
    },

    contentLoading: {
      type: Boolean,
    },

    orderReference: {
      type: String,
      default: '',
    },

    isParkingProduct: {
      type: Boolean,
      default: false,
    },

    modifications: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    /**
     * Filtered items to not contain bundle items
     * @returns a new filtered array
     */
    filteredItems(): PurchaseProduct[] {
      return this.items.filter((item) => !item.bundle_id);
    }
  },
});
